<template>
<panel>
  <p slot="header">
    Dodaj grupę
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.email-groups.dashboard'})">Wróć do grup</ui-button>
  </p>
  <email-groups-form :item="item"></email-groups-form>
</panel>

</template>
<script>
import EmailGroups from './../../services/EmailGroups'

export default {
  data () {
    return {
      item: EmailGroups.getBaseItem()
    }
  },
  mounted () {
  }
}

</script>


// WEBPACK FOOTER //
// Create.vue?71c87060